import { useState, useEffect,useMemo } from "react";
import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { Button } from "@material-ui/core";
import Spacer from "../../components/Spacer";
import MainContainer from "../../components/MainContainer";
import { headerGardian } from "../../data/gardian_header";
import PersonnelService from "../../services/PersonnelService";
import { userDetailContext } from "../../App";
import { useContext } from "react";
import { hasPrivilege } from "../../utils/privilege";
import { useNavigate } from 'react-router-dom';
import PlanningMissionService from "../../services/PlanningMissionService";
import UserService from "../../services/UserService";
import {TextField} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SearchIcon from '@mui/icons-material/Search';
import LoadingButton from '@mui/lab/LoadingButton';
import GardianService from "../../services/GardianService";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Message from "../tools/Message";
import { 
    Box, 
    Typography, 
     Accordion,
      AccordionSummary,
      AccordionDetails,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Checkbox,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions
  } from '@mui/material';
  import { DatePicker } from '@mui/x-date-pickers';
  import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
  import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
  import { format, addMonths, subMonths, getYear , setDate} from 'date-fns';
  import frLocale from 'date-fns/locale/fr';
  import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
  import LoadingSimpleBackdrop from "../tools/LoadingSimpleBackdrop";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 0,
  },
  button: {
    float: 'right',
  },
}));

export default function GardianAdd() {
  const navigate = useNavigate();
  const classes = useStyles();
  const contextData = useContext(userDetailContext);
  const [direction,setDirection]=useState([]);
   const [selectedDirection, setSelectedDirection] = useState('all');
   const [isLoading, setIsLoading] = useState(false);
   const [personnelData,setPersonnelData]=useState([]);
   const [selectuser,setSelectuser]=useState(null);
   const [openLoadingSimpleBackdrop,setOpenLoadingSimpleBackdrop]=useState(false);

    const currentYear = new Date().getFullYear();
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [currentMonth, setCurrentMonth] = useState(new Date());
    const [selections, setSelections] = useState({});

    const [selectUser, setSelectUser] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [pendingSelection, setPendingSelection] = useState(null);
    const [expanded, setExpanded] = useState({});
    const [message, setMessage] = React.useState({
             open: false,
             color: "green",
             messageInfo: "",
           });
    const { open, color, messageInfo } = message;

    // Génère les années du currentYear jusqu'à aujourd'hui
    const years = Array.from({ length: currentYear - 2024 }, (_, i) => 2025 + i);

  //     const days = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];

  // const handleCheckboxChange = (personId, userId, day) => {
  //   setSelections(prev => ({
  //     ...prev,
  //     [`${personId}-${day}`]: !prev[`${personId}-${day}`]
  //   }));
  // };

  const handleAccordionChange = (name) => (event, isExpanded) => {
    setExpanded(prev => ({
      ...prev,
      [name]: isExpanded
    }));
  };

    const [dialogContent, setDialogContent] = useState({
      title: '',
      content: null
    });


 
  // Génère les jours du mois
  const daysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    return new Date(year, month + 1, 0).getDate();
  };

  const days = Array.from({ length: daysInMonth(currentMonth) }, (_, i) => i + 1);

    const handleMonthChange = (increment) => {
        setCurrentMonth(increment ? addMonths(currentMonth, 1) : subMonths(currentMonth, 1));
        const newMonth = increment ? addMonths(currentMonth, 1) : subMonths(currentMonth, 1);
        
        setSelectedYear(newMonth.getFullYear());
        
        const userData = localStorage.getItem('USER');
        if (userData) {
          setOpenLoadingSimpleBackdrop(true);
        UserService.getUserSummaryByUserId(userData)
            .then((result) => {
            if (result && result.data) {
                const dirpers = result.data.direction_id;
                
                GardianService.getlisteadd(dirpers,format(increment ? addMonths(currentMonth, 1) : subMonths(currentMonth, 1), 'M'),selectedYear).then((result) => {
                  if (result && result.data) {   
                    setPersonnelData(result.data);
                    setSelections(result.selection);
                      setOpenLoadingSimpleBackdrop(false);
                  }
                  }).catch((error) => {
                    setPersonnelData([]);
                    setSelections([]);
                    setOpenLoadingSimpleBackdrop(false);
                  });
            }
            })
            .catch((error) => {

            });
        }
    };

    const handleCheckboxChange = (personId, userId, day) => {
      // setPendingSelection({
      //   personId,
      //   userId,
      //   day,
      //   newValue: !selections[`${personId}-${day}`]
      // });
      //setOpenDialog(true);

        setSelections(prev => ({
          ...prev,
          [`${personId}-${day}`]: !selections[`${personId}-${day}`]
        }));
    };

          const handleConfirm = () => {

                const allSelectedPersons = [];

                Object.entries(groupedData).forEach(([groupName, personGroup]) => {
                  const personsWithSelections = personGroup.filter(person => 
                    days.some(day => selections[`${person.id}-${day}`]) && selectUser === person.user_id
                  );
                  
                  allSelectedPersons.push(...personsWithSelections);
                });
                

                const filteredSelections = {};

                // Récupérer tous les ids des personnes sélectionnées
                const selectedIds = allSelectedPersons.map(person => person.id);

                // Filtrer les selections
                Object.entries(selections).forEach(([key, value]) => {
                  const [idStr, day] = key.split('-');
                  const id = parseInt(idStr);
                  
                  // if (selectedIds.includes(id) && value === true) {
                  //   filteredSelections[key] = value;
                  // }
                  if (selectedIds.includes(id)) {
                    filteredSelections[key] = value;
                  }
                });

                GardianService.add(format(currentMonth, 'M'),selectedYear,filteredSelections,selectUser,allSelectedPersons).then((result) => {
                  if (result ) {   
                    setOpenDialog(false);
                     setMessage({ ...message, open: true, color: 'green', messageInfo: "Succès" });
                  }
                  }).catch((error) => {
                       setOpenDialog(false);
                     setMessage({ ...message, open: true, color: 'green', messageInfo: "Erreur" });
                  });       
     };



    const handleCancel = () => {
      setOpenDialog(false);
      setPendingSelection(null);
    };
  
  useEffect(() => {
        const userData = localStorage.getItem('USER');
        if (userData) {
        setOpenLoadingSimpleBackdrop(true);
        UserService.getUserSummaryByUserId(userData)
            .then((result) => {
            if (result && result.data) {
                const dirpers = result.data.direction_id;
                
                GardianService.getlisteadd(dirpers,format(currentMonth, 'M'),selectedYear).then((result) => {
                  if (result && result.data) {   
                    setPersonnelData(result.data);
                    setSelections(result.selection);
                    setOpenLoadingSimpleBackdrop(false);
                  }
                  }).catch((error) => {
                    setPersonnelData([]);
                    setSelections([]);
                    setOpenLoadingSimpleBackdrop(false);
                  });
            }
            })
            .catch((error) => {

            });
        }
    }, []);

     const groupedData = personnelData.reduce((acc, person) => {
        if (!acc[person.name]) acc[person.name] = [];
        acc[person.name].push(person);
        return acc;
      }, {});

      const handleSave = () => {
        console.log('Sélections à enregistrer :', selections);
        // Ajoutez ici votre logique d'enregistrement
      };

      const handleSaveForGroup = (groupName) => {
        const groupSelections = Object.keys(selections)
          .filter(key => {
            const personId = key.split('-')[0];
            const person = personnelData.find(p => p.id === personId);
            return person?.name === groupName;
          })
          .reduce((obj, key) => {
            obj[key] = selections[key];
            return obj;
          }, {});

      

      };

      function handleCloseMessage() {
        setMessage({ ...message, open: false });
      }


  return (
    <MainContainer {...headerGardian}>
       <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
        <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
      <Spacer y={2} />
      <Grid container spacing={3}>

        <Grid item xs={12}>
          <Paper className={classes.paper} variant="outlined">
              <Box sx={{ p: 3 }}>
               <Typography variant="h5" gutterBottom style={{textAlign:"center"}}>Jour de repos du gardien</Typography>
               <Spacer y={2} />
                <Grid container item xs={12}>
                    <Grid item xs={12}>
                    </Grid>
                    <Grid item xs={4}>
                    </Grid>
                    <Grid item xs={8}>    
                        <Box sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            mb: 3,
                            gap: 2 
                        }}>
                            <Button 
                                variant="contained" 
                                onClick={() => handleMonthChange(false)}
                                sx={{ 
                                    mr: 2,
                                    px: 3, 
                                    py: 1.5
                                }}
                            >
                                <ArrowBackIosIcon/>
                            </Button>
                            
                            <Typography 
                                variant="h6"
                                sx={{
                                    textTransform: 'uppercase', 
                                    fontWeight: 'bold', 
                                    letterSpacing: '0.5px',
                                    mx: 2 
                                }}
                            >
                                {format(currentMonth, 'MMMM yyyy', { locale: frLocale })}
                            </Typography>
                            
                            <Button 
                                variant="contained" 
                                onClick={() => handleMonthChange(true)}
                                sx={{ 
                                    ml: 2,
                                    px: 3, 
                                    py: 1.5
                                }}
                            >
                              <ArrowForwardIosIcon/>
                            </Button>
                        </Box>
                    </Grid>
                 </Grid>
                            <Box sx={{ width: '100%' }}>
                                {Object.entries(groupedData).map(([name, personGroup], groupIndex) => (
                                  <Accordion
                                    key={`${name}-${groupIndex}`}
                                    expanded={groupIndex === 0 || expanded[name] || false} 
                                    onChange={handleAccordionChange(name)}
                                  >
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      sx={{ 
                                        backgroundColor: '#f5f5f5',
                                        borderBottom: '1px solid #e0e0e0',
                                        minHeight: '48px !important',
                                        '&.Mui-expanded': {
                                          minHeight: '48px !important'
                                        }
                                      }}
                                    >
                                      <Box sx={{ 
                                        display: 'flex', 
                                        justifyContent: 'space-between', 
                                        alignItems: 'center',
                                        width: '100%',
                                        pr: 2
                                      }}>
                                        <Typography sx={{ fontWeight: 'bold' }}>{name}</Typography>
                                        <Button 
                                          variant="contained" 
                                          size="small"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                       
                                            let hasSelections = false;

                                                for (const person of personGroup) {
                                                  for (const day of days) {
                                                    if (selections[`${person.id}-${day}`]) {
                                                      setSelectUser(person.user_id);
                                                      hasSelections = true;
                                                      break;
                                                    }
                                                  }
                                                  if (hasSelections) break;
                                                }
            
                                            if (hasSelections) {
                                              const summary = personGroup.map(person => ({
                                                name: person.type,
                                                days: days.filter(day => selections[`${person.id}-${day}`])
                                              }));
                                              
                                              setDialogContent({
                                                title: `Résumé pour ${name}`,
                                                content: (
                                                  <Box>
                                                    {summary.map((item, idx) => (
                                                      <Box key={idx} sx={{ mb: 2 }}>
                                                        <Typography variant="subtitle1">{item.name}</Typography>
                                                        <Typography>
                                                          Jours de repos sélectionnés: {item.days.join(', ') || 'Aucun'}
                                                        </Typography>
                                                      </Box>
                                                    ))}
                                                  </Box>
                                                )
                                              });
                                              setOpenDialog(true);
                                              handleSaveForGroup(name);
                                            }
                                          }}
                                          disabled={!personGroup.some(person => 
                                            days.some(day => selections[`${person.id}-${day}`])
                                          )}
                                          sx={{
                                            backgroundColor: '#1976d2',
                                            color: 'white',
                                            '&:hover': {
                                              backgroundColor: '#1565c0'
                                            },
                                            '&:disabled': {
                                              backgroundColor: '#e0e0e0',
                                              color: '#a0a0a0'
                                            }
                                          }}
                                        >
                                          Enregistrer
                                        </Button>
                                      </Box>
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ p: 0 }}>
                                      <TableContainer component={Paper}>
                                        <Table sx={{ tableLayout: 'fixed' }}>
                                          <TableHead>
                                            <TableRow>
                                              <TableCell sx={{ width: 100, fontWeight: 'bold' }}>Type</TableCell>
                                              {days.map(day => (
                                                <TableCell 
                                                  key={day} 
                                                  align="center" 
                                                  sx={{ 
                                                    width: 15,
                                                    fontWeight: 'bold',
                                                    padding: '6px' 
                                                  }}
                                                >
                                                  {day}
                                                </TableCell>
                                              ))}
                                            </TableRow>
                                          </TableHead>
                                          
                                          <TableBody>
                                           {personGroup.map((person, personIndex) => (
                                              <TableRow key={`${person.id}-${personIndex}`}>
                                                <TableCell sx={{ 
                                                  width: 100,
                                                  borderRight: '1px solid #e0e0e0', 
                                                  backgroundColor: '#f9f9f9' 
                                                }}>
                                                  {person.type}
                                                </TableCell>
                                                {days.map((day, dayIndex) => (
                                                  <TableCell 
                                                    key={day} 
                                                    align="center" 
                                                    sx={{ 
                                                      width: 15,
                                                      padding: '4px',
                                                      height: '20px',
                                                      borderRight: dayIndex < days.length - 1 ? '1px solid #f0f0f0' : 'none', 
                                                      backgroundColor: dayIndex % 2 === 0 ? '#f4f4f4' : '#fafafa', 
                                                      justifyContent:'center',
                                                      alignItems:'center'
                                                    }}
                                                  >
                                                    <Checkbox
                                                      checked={!!selections[`${person.id}-${day}`]}
                                                      onChange={() => handleCheckboxChange(person.id, person.user_id, day)}
                                                      sx={{ 
                                                        padding: 0,
                                                        '&.Mui-checked': {
                                                          color: '#1976d2'
                                                        }
                                                      }}
                                                    />
                                                  </TableCell>
                                                ))}
                                              </TableRow>
                                            ))}
                                          </TableBody>
                                        </Table>
                                      </TableContainer>
                                    </AccordionDetails>
                                  </Accordion>
                                ))}
                                
                                
                              </Box>

                                <Dialog
                                  open={openDialog}
                                  onClose={handleCancel}
                                  aria-labelledby="alert-dialog-title"
                                  aria-describedby="alert-dialog-description"
                                  maxWidth="md" 
                                  fullWidth 
                                >
                                  <DialogTitle id="alert-dialog-title">
                                    Confirmation jours de repos
                                  </DialogTitle>
                                  <DialogContent>
                                    <DialogContentText id="alert-dialog-description" component="div">
                                      {openDialog && ( 
                                       <Box>
                                          {Object.entries(groupedData).map(([groupName, personGroup], groupIndex) => {
                                        
                                            const personsWithSelections = personGroup.filter(person => 
                                              days.some(day => selections[`${person.id}-${day}`] && selectUser === person.user_id )
                                            );
                                            if (personsWithSelections.length === 0) return null;

                                            return (
                                              <Box key={groupIndex} sx={{ mb: 4 }}>
                                                <Typography variant="subtitle1" sx={{ 
                                                  fontWeight: 'bold', 
                                                  mb: 2,
                                                  color: 'primary.main'
                                                }}>
                                                  {groupName}
                                                </Typography>
                                                
                                                {personsWithSelections.map((person, personIndex) => {
                                                  const selectedDays = days.filter(day => selections[`${person.id}-${day}`]);
                                                  
                                                  return (
                                                    <Box key={`${groupIndex}-${personIndex}`} sx={{ 
                                                      mb: 2,
                                                      pl: 2,
                                                      borderLeft: '3px solid',
                                                      borderColor: 'divider'
                                                    }}>
                                                      <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                                                        {person.type}
                                                      </Typography>
                                                      {/* <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                                        Jours sélectionnés: {selectedDays.length > 0 ? selectedDays.join(', ') : 'Aucun'}
                                                      </Typography> */}
                                                     
                                                      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                                        Jours sélectionnés : {
                                                          selectedDays.length > 0
                                                            ? selectedDays
                                                                .map((day) =>
                                                                  format(setDate(currentMonth, day), 'd MMMM yyyy', { locale: frLocale  })
                                                                )
                                                                .join(', ')
                                                            : 'Aucun'
                                                        }
                                                      </Typography>
                                                    </Box>
                                                  );
                                                })}
                                              </Box>
                                            );
                                          })}
                                        </Box>
                                      )}
                                    </DialogContentText>
                                  </DialogContent>
                                  <DialogActions>
                                    <Button onClick={handleCancel} color="primary">
                                      Annuler
                                    </Button>
                                    <Button 
                                      onClick={handleConfirm} 
                                      color="primary" 
                                      autoFocus
                                      variant="contained"
                                    >
                                      Confirmer
                                    </Button>
                                  </DialogActions>
                                </Dialog>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </MainContainer>
  );
}
